import { render, staticRenderFns } from "./UploaderV2.vue?vue&type=template&id=2c2c5448&scoped=true"
import script from "./UploaderV2.vue?vue&type=script&lang=js"
export * from "./UploaderV2.vue?vue&type=script&lang=js"
import style0 from "./UploaderV2.vue?vue&type=style&index=0&id=2c2c5448&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c5448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2c5448')) {
      api.createRecord('2c2c5448', component.options)
    } else {
      api.reload('2c2c5448', component.options)
    }
    module.hot.accept("./UploaderV2.vue?vue&type=template&id=2c2c5448&scoped=true", function () {
      api.rerender('2c2c5448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/UploaderV2.vue"
export default component.exports